import styled from 'styled-components';

export const UploadFileLink = styled.a`
  text-decoration: underline;
  display: inline-block;
`;
